webpackJsonp([114276838955818,60335399758886],{

/***/ 217:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(544);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(217);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(574), __esModule: true };

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(606);
	module.exports = __webpack_require__(23).Object.keys;


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(95);
	var $keys = __webpack_require__(93);
	
	__webpack_require__(189)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(211);
	var isArguments = __webpack_require__(210);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(559);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(92);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(8);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(7);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(172);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(to) {
	  window.___navigateTo(to);
	};

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(264);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(209);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(260);
	
	var _HelmetConstants = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(18);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(213));
	var shallowEqual = _interopDefault(__webpack_require__(296));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(21);
	
	var _gatsbyLink = __webpack_require__(669);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterMenu = function (_Component) {
	  _inherits(FooterMenu, _Component);
	
	  function FooterMenu() {
	    _classCallCheck(this, FooterMenu);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FooterMenu.prototype.render = function render() {
	    return _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { className: "main_content" },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { doubling: true, columns: 3, centered: true, divided: true, stretched: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  { as: "h4" },
	                  "waller-welt.com"
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "marker" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  "46030 Borgoforte ( MN ) Italien"
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "phone" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Tel: 0039-345-9973997"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "mail" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "mailto:info@wallerwelt.com" },
	                    "info@wallerwelt.com"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "linkify" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "http://www.wallerwelt.com" },
	                    "wallerwelt.com"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "facebook", size: "big", verticalAlign: "middle" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Waller-Welt"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "facebook", size: "big", verticalAlign: "middle" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://www.facebook.com/groups/1148607495253649/" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Wallerangeln am Po"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(_semanticUiReact.List.Icon, { name: "youtube", size: "big", verticalAlign: "middle" }),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://www.youtube.com/channel/UCaKUrQs8CS66HTn2QA1o2Jg" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Mister Waller"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/kontakt" },
	                    "Kontakt"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/datenschutz" },
	                    "Datenschutz"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/impressum" },
	                    "Impressum"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Content,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/agb" },
	                    "AGB"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            {
	              textAlign: "center" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\xA9 2021 wallerwelt.com - created by ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.siluri.de" },
	                "siluri.de"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FooterMenu;
	}(_react.Component);
	
	exports.default = FooterMenu;
	module.exports = exports["default"];

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderMenu = function (_Component) {
	  _inherits(HeaderMenu, _Component);
	
	  function HeaderMenu() {
	    _classCallCheck(this, HeaderMenu);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.handleItemClick = function (e, _ref) {
	      var name = _ref.name;
	
	      _this.setState({ activeItem: name });
	      console.log(_this.state);
	    };
	
	    _this.handleItemClickMobile = function (e, _ref2) {
	      var name = _ref2.name;
	
	      _this.setState({ activeItem: name });
	      console.log(_this.state);
	      _this.toggleVisibility();
	    };
	
	    _this.toggleVisibility = function () {
	      _this.setState({ visible: !_this.state.visible });
	      console.log(_this.state);
	    };
	
	    _this.state = {
	      visible: true,
	      activeItem: "home"
	    };
	    return _this;
	  }
	
	  HeaderMenu.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        _semanticUiReact.Responsive.onlyMobile,
	        _react2.default.createElement(
	          _semanticUiReact.Menu,
	          { size: "large", inverted: true, fixed: "top", className: "main_header" },
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Item,
	            { onClick: this.toggleVisibility },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: "content" }),
	            "\xA0Men\xFC"
	          )
	        ),
	        !this.state.visible && _react2.default.createElement(
	          _semanticUiReact.Menu,
	          {
	            size: "large",
	            inverted: true,
	            fixed: "top",
	            className: "main_header",
	            stackable: true
	          },
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Home",
	            active: this.props.activeItem === "home",
	            onClick: this.handleItemClickMobile,
	            href: "/#Home"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Service",
	            active: this.props.activeItem === "service",
	            onClick: this.handleItemClickMobile,
	            href: "/#service"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Mittellauf",
	            active: this.props.activeItem === "Mittellauf",
	            onClick: this.handleItemClickMobile,
	            href: "/#Mittellauf"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Oberlauf",
	            active: this.props.activeItem === "Oberlauf",
	            onClick: this.handleItemClickMobile,
	            href: "/#Oberlauf"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Boote",
	            active: this.props.activeItem === "Leihboote",
	            onClick: this.handleItemClickMobile,
	            href: "/#Leihboote"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Guiding",
	            active: this.props.activeItem === "Guiding",
	            onClick: this.handleItemClickMobile,
	            href: "/#Guiding"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Preise",
	            active: this.props.activeItem === "Preise",
	            onClick: this.handleItemClickMobile,
	            href: "/#Preise"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Events",
	            active: this.props.activeItem === "Events",
	            onClick: this.handleItemClickMobile,
	            href: "/#Events"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Kontakt",
	            active: this.props.activeItem === "Kontakt",
	            onClick: this.handleItemClickMobile,
	            href: "/kontakt"
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        { minWidth: _semanticUiReact.Responsive.onlyTablet.minWidth },
	        _react2.default.createElement(
	          _semanticUiReact.Menu,
	          {
	            size: "large",
	            inverted: true,
	            fixed: "top",
	            className: "main_header",
	            stackable: true
	          },
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Home",
	            active: this.props.activeItem === "home",
	            onClick: this.handleItemClick,
	            href: "/#Home"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Service",
	            active: this.props.activeItem === "service",
	            onClick: this.handleItemClick,
	            href: "/#service"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Mittellauf",
	            active: this.props.activeItem === "Mittellauf",
	            onClick: this.handleItemClick,
	            href: "/#Mittellauf"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Oberlauf",
	            active: this.props.activeItem === "Oberlauf",
	            onClick: this.handleItemClick,
	            href: "/#Oberlauf"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Boote",
	            active: this.props.activeItem === "Leihboote",
	            onClick: this.handleItemClick,
	            href: "/#Leihboote"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Guiding",
	            active: this.props.activeItem === "Guiding",
	            onClick: this.handleItemClick,
	            href: "/#Guiding"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Preise",
	            active: this.props.activeItem === "Preise",
	            onClick: this.handleItemClickMobile,
	            href: "/#Preise"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Events",
	            active: this.props.activeItem === "Events",
	            onClick: this.handleItemClickMobile,
	            href: "/#Events"
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: "Kontakt",
	            active: this.props.activeItem === "Kontakt",
	            onClick: this.handleItemClickMobile,
	            href: "/kontakt"
	          })
	        )
	      )
	    );
	  };
	
	  return HeaderMenu;
	}(_react.Component);
	
	exports.default = HeaderMenu;
	module.exports = exports["default"];

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(116);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _logoMin = __webpack_require__(1108);
	
	var _logoMin2 = _interopRequireDefault(_logoMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var desc = "Der Bootsverleih und Guidungservice am PO",
	        title = "wallerwelt.com",
	        url = "https://wallerwelt.com",
	        fbAppId = "";
	
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "Organization",
	      url: url,
	      sameAs: ["https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/", "https://www.facebook.com/WallerWelt2.0/"],
	      address: {
	        "@type": "PostalAddress",
	        addressLocality: "Borgoforte, Italien",
	        postalCode: "IT-46030",
	        streetAddress: "Via Al Ponte 1"
	      },
	      email: "info(at)wallerwelt.com",
	      alumni: [{
	        "@type": "Person",
	        name: "Markus Eule"
	      }],
	      member: [{
	        "@type": "Organization"
	      }],
	      name: "Waller-Welt (Waller-Welt.com)",
	      contactPoint: [{
	        "@type": "ContactPoint",
	        telephone: "+39-345-997-3997",
	        contactType: "customer service"
	      }]
	    }];
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      { htmlAttributes: { lang: "de", amp: undefined } },
	      _react2.default.createElement("meta", { name: "description", content: desc }),
	      _react2.default.createElement("meta", { name: "image", content: _logoMin2.default }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:url", content: url }),
	      _react2.default.createElement("meta", { property: "og:type", content: "website" }),
	      _react2.default.createElement("meta", { property: "og:description", content: desc }),
	      _react2.default.createElement("meta", { property: "og:image", content: _logoMin2.default }),
	      _react2.default.createElement("meta", {
	        property: "fb:app_id",
	        content: fbAppId.length > 0 ? fbAppId : ""
	      })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports["default"];

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(536);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(534);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SEO = __webpack_require__(541);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	__webpack_require__(656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "main" },
	    _react2.default.createElement(_SEO2.default, null),
	    _react2.default.createElement(_Header2.default, null),
	    children(),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-781d70762b142192f019.js